import apiSlice from 'renderer/shared/state/apiSlice';
// import {
//   CreateDiscountRequest,
//   CreateDiscountResponse,
//   CreateDiscountResponseSchema,
//   DeleteDiscountRequest,
//   DeleteDiscountResponse,
//   DeleteDiscountResponseSchema,
//   GetDiscountRequest,
//   GetDiscountResponse,
//   GetDiscountResponseSchema,
//   ListDiscountsRequest,
//   ListDiscountsResponse,
//   ListDiscountsResponseSchema,
//   UpdateDiscountRequest,
//   UpdateDiscountResponse,
//   UpdateDiscountResponseSchema,
// } from '../schemas/discounts.schemas';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // listDiscounts: builder.query<ListDiscountsResponse, ListDiscountsRequest>({
    listResellerCodes: builder.query({
      query: () => '/reseller-code',
      providesTags: ['ResellerCode'],
      // extraOptions: {
      //   responseSchema: ListDiscountsResponseSchema,
      // },
    }),
    // getDiscount: builder.mutation<GetDiscountResponse, GetDiscountRequest>({
    getResellerCode: builder.mutation({
      query: (code) => ({
        url: `/reseller-code/${code}`,
        method: 'GET',
      }),
      // providesTags: ['Discount'],
      // extraOptions: {
      //   responseSchema: GetDiscountResponseSchema,
      // },
    }),
    // createDiscount: builder.mutation<
    //   CreateDiscountResponse,
    //   CreateDiscountRequest
    // >({
    createResellerCode: builder.mutation({
      query: (body) => ({
        url: '/reseller-code',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ResellerCode'],
      // extraOptions: {
      //   responseSchema: CreateDiscountResponseSchema,
      // },
    }),
    // updateDiscount: builder.mutation<
    //   UpdateDiscountResponse,
    //   UpdateDiscountRequest
    // >({
    updateResellerCode: builder.mutation({
      query: (req) => ({
        url: `/reseller-code/${req._id}`,
        method: 'PUT',
        body: req,
      }),
      invalidatesTags: ['ResellerCode'],
      // extraOptions: {
      //   responseSchema: UpdateDiscountResponseSchema,
      // },
    }),
    deleteResellerCode: builder.mutation({
      query: (id) => ({
        url: `/reseller-code/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ResellerCode'],
      // extraOptions: {
      //   responseSchema: DeleteDiscountResponseSchema,
      // },
    }),
    redeemResellerCode: builder.mutation({
      query: (body) => ({
        url: `/reseller-code/redeem`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ResellerCode'],
    }),
  }),
});

export const {
  useListResellerCodesQuery,
  useGetResellerCodeMutation,
  useCreateResellerCodeMutation,
  useUpdateResellerCodeMutation,
  useDeleteResellerCodeMutation,
  useRedeemResellerCodeMutation,
} = extendedApi;
